import {Observable} from 'rxjs';
import {Parameter} from '../common/parameter';
import { Binary } from '@angular/compiler';

export interface AssetMstParameter extends Parameter {
    searchTerm: number;
    orderBy: string;

}

export interface IvfDonorMst {
    id?: any;
 
    name: string;
    age: Number;
    tenantId: any;
    branchId: any;
    gender: string;
    mobile:string;
    email: string;
    communicationAddress: any;
    type: string;
    
    createdBy: any;
    createdDate: any;
    updatedBy:any;
    udatedDate: any;
 
    parameters?: AssetMstParameter[];
    links?: any;
}

export abstract class IvfDonorMstData {
   
    abstract list(url: string): Observable<IvfDonorMst[]>;
    abstract create(url: string, data: IvfDonorMst): Observable<IvfDonorMst[]>;
    abstract update(url: string, data: IvfDonorMst): Observable<IvfDonorMst>;
    abstract delete(url: string): Observable<any>;
}